import { Box, Container, Paper, Typography } from "@mui/material";
import { DonutLargeRounded } from "@mui/icons-material";

import { Chip } from "@mui/material";
import { AttachMoneyRounded } from "@mui/icons-material";
import { palette, theme as colorTheme } from "../../../../Convoze.theme";



export function OpportunityItem({ title, revenueNote, suggestion, callId }) {
  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: 5,
        p: { xs: 1.5, sm:"1rem" },
        backgroundColor: "#FAFAFB",
      }}
    >
      {/* Title */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
        //   mb: 0.5,
        //   flexWrap: "wrap",
        }}
      >
        <AttachMoneyRounded sx={
          // { color: "#FACC15" }
          {color: colorTheme('palette', 'neutral').value}
          } />
        <Typography
          variant="subtitle2"
          sx={{fontSize: "0.9rem" }}
        >
          {suggestion}
        </Typography>
      </Box>

      {/* Revenue note */}

      {/* <Typography
        variant="body2"
        sx={{
          color: "hsl(240 3.8% 46.1%)",
          fontSize: "0.87rem",
          lineHeight: "1.25rem",
          mb: 2,
        }}
      >
        {" "}
        {revenueNote}
      </Typography> */}

      {/* Suggestion strip */}
      {/* <Box
        sx={{
          bgcolor: "#EEF2FF",
          borderRadius: 5,
          p: { xs: 1, sm: 1.25 },
          mb: 1.25, 
          fontSize: "0.875rem",
          lineHeight: "1.25rem",
          display:'flex',
        }}
      >
        <Typography
          variant="body2"
          sx={{ fontSize: "0.8rem", lineHeight: "1.25rem", color: "#09090B" }}
        >
             <AttachMoneyRounded sx={{ color: "#FACC15" }} />
          <b>{"Suggestion: "}</b>
          {suggestion}
        </Typography>
      </Box> */}

      {/* Call ID pill */}
      {/* <Chip
        size="small"
        label={`Call ID: ${callId}`}
        sx={{
          height: 24,
          bgcolor: "#fff",
          border: "1px solid #e5e7eb",
          "& .MuiChip-label": { px: 1 },
          fontWeight: 600,
          fontSize:"0.75rem",
          lineHeight:'1rem'
        }}
      /> */}
    </Paper>
  );
}

